import React, { useState } from 'react'

import { Box, Button, Grid, Typography } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

import { LoadingFeedback } from 'components'
import OTPForm from './components/OTPForm'
import ResendEmail from './components/ResendEmail'

import useAuthGuest from 'hooks/useAuthGuest'
import useGuestJourney from 'hooks/useGuestJourney'
import useSnackbar from 'hooks/useSnackbar'

import { reverse } from 'named-urls'

import helpers from 'helpers'
import * as service from 'service'
import { PROFILE_SETUP_STEP_INDEX } from 'views/Guests/Journey/Journey'
import useStyles from './styles'

const TwoFactorAuthenticationStep = () => {
  const [isLoading, setIsLoading] = useState(false)

  const classes = useStyles()
  const snackbar = useSnackbar()
  const { handleSubmit } = useFormContext()
  const { setUser: setAuthUser } = useAuthGuest()
  const { accessToken, companyInfo, redirectPath, setActiveStep, user } =
    useGuestJourney()

  const onSubmit = async (data) => {
    try {
      setIsLoading(true)

      const response = await service.guestPortal.auth.login(
        data.code,
        accessToken,
      )

      const authToken = response?.data?.authToken
      service.guestPortal.auth.setToken(authToken)

      const profileResponse = await service.guestPortal.profile.get()
      const guestUser = profileResponse?.data?.guestUser

      setAuthUser({
        id: guestUser?.id,
        responsibleName: guestUser?.responsibleName || null,
        departmentId: guestUser?.departmentId || null,
      })

      const hasProfile = guestUser?.responsibleName && guestUser?.departmentId
      if (!hasProfile) {
        setActiveStep(PROFILE_SETUP_STEP_INDEX)
      } else {
        service.history.push(redirectPath)
      }
    } catch (error) {
      const status = error?.response?.status

      if (status === 401) {
        snackbar.open({
          message: 'Sessão expirada. Informe o e-mail novamente.',
          variant: 'error',
        })
        setActiveStep(0)
        return
      }

      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Código inválido. Tente novamente.',
        variant: 'error',
      })
    } finally {
      setTimeout(() => setIsLoading(false), 500)
    }
  }

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <form id="form-register" onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} md={8}>
            <Typography color="primary" className={classes.title}>
              {companyInfo?.name}
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Typography color="primary" className={classes.subtitle}>
              Verificação em duas etapas. Enviamos um código de 5 dígitos para{' '}
              <strong>{user?.email}</strong>. Informe-o abaixo para concluir o
              acesso.
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              className={classes.codeBox}
              px={3}
              py={3}
            >
              <OTPForm />
              <ResendEmail email={user?.email} />
            </Box>
          </Grid>
          <Grid item xs={12} md={8}>
            <Box className={classes.formFooter}>
              <Button
                form="form-register"
                type="submit"
                variant="contained"
                color="secondary"
                className={classes.submitButton}
              >
                Acessar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default TwoFactorAuthenticationStep
